import { ProductGroup } from './ProductGroup'

export class ProductConfig {
  constructor ({ possibleLoyalties, productGroups }) {
    this.possibleLoyalties = possibleLoyalties
    this.productGroups = []
    productGroups.forEach(group => {
      this.productGroups.push(new ProductGroup(group))
    })
  }
}
